import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserData } from "../../../api/models/commonUserAttributes";
import { PlacardEditionResponse } from "../../../api/models/placardEdit";
import { ApiErrorCode, ServiceURLConstants } from "../../../constants/upplm.constants";
import { NotificationChangesHelperService } from "../../../services/PlacardEditionServices/upplm.notificationChangesHelper.service";
import { UpplmApiService } from "../../../services/upplm.api.services";
import { UpsCommonService } from "../../../services/upplm.common.service";
import { ConfigurationService } from "../../../services/upplm.configuration.service";
import { PlacardEditionService } from "../../../services/upplm.placardEdition.service";
import { StoredDataService } from "../../../services/upplm.storedData.service";
import { UpsDialogComponent } from "../../commonComponent/ups-dialog/ups-dialog.component";

@Component({
    selector: 'notificationchanges',
    template: require('./notificationChanges.component.html'),
    providers: [PlacardEditionService, NotificationChangesHelperService]
})

export class NotificationChangesComponent implements OnInit {

    @ViewChild('confirmSaveModal', { static: false }) confirmSaveModal: UpsDialogComponent;
    @ViewChild('genericErrorModal', { static: false }) unsuccessModal: UpsDialogComponent;
    @ViewChild('succesModal', { static: false }) succesModal: UpsDialogComponent;

    notificationForm: FormGroup;
    submitted: boolean = false;
    emails: any[] = [];
    maxEmails: number = 10;
    @Output() showNotificationChanges = new EventEmitter<boolean>();
   

    constructor(private _storedDataService: StoredDataService,
        private _placardEditionService: PlacardEditionService,
        private _notificationChangesHelperService: NotificationChangesHelperService,
        private formBuilder: FormBuilder,
        private _apiService: UpplmApiService,
        private _commonService: UpsCommonService,
        private _configurationService: ConfigurationService) {
        this.notificationForm = this.formBuilder.group({
            changeJustification: ['', [Validators.required]]
        });
    }

    ngOnInit(): void {
        
        const urlUserAttributesApi = this._commonService.createURL(ServiceURLConstants.GET_COMMON_USER_ATTRIBUTES, ApiErrorCode.GET_COMMON_USER_ATTRIBUTES);
        this._apiService.PostServiceAPI(urlUserAttributesApi, null).subscribe((response: any) => {
            this.getUserDataInformation(response);
        });
    }

    getUserDataInformation(response: any) {
        let email: string = '';
        let userData = new UserData();
        if (!response.errors) {
            userData.email = response.email;
            userData.name = response.userId;
            userData.userId = response.userId;
            email = response.email;
        } else {
            userData.email = 'UPSPickupPointApplicationTeam@ups.com';
            userData.name = 'UPP_Team';
            userData.userId = 'UPP_Team';
            email = 'UPSPickupPointApplicationTeam@ups.com';
        }
        this._storedDataService.userDataInformation = userData;
        this.initializeEmails(email);
    }

    returnToEditView() {
        this.showNotificationChanges.emit(false); //Close
    }

    initializeEmails(initialEmail: string = '') {
        let hasEmailValue: boolean = initialEmail.length > 0 ? true : false;
        this.emails = [{ email: initialEmail, notifyApproved: true, notifyRejected: true, isValid: hasEmailValue, required: true }];
    }

    removeEmail(idx) {
        this.emails.splice(idx, 1);
    }

    addEmail() {
        this.emails.push({ email: '', notifyApproved: true, notifyRejected: true, isValid: false });
    }

    confirmChanges() {
        this.submitted = true;
        this.notificationForm.controls.changeJustification.markAsDirty();
        if (this.notificationForm.invalid || this.emails.find(e => !e.isValid)) {
            return;
        }
        this.confirmSaveModal.open();
    }

    async confirmSaveYes() {
        // Logic to save edition
        this._notificationChangesHelperService.setAdditionalValuesToEditRequest(this.changeJustification, this.emails);
        let placardEditionResponse = new PlacardEditionResponse();
        placardEditionResponse = await this._placardEditionService.editPlacard(this._storedDataService.placardId, this._storedDataService.requestEditedData);
        this.confirmSaveModal.close();
        if (placardEditionResponse.errors) {
            this._storedDataService.isEditionComplete = false;
            this.unsuccessModal.open();
        } else {
            if (placardEditionResponse.updatedRequestSaved) {

                if (placardEditionResponse.autoApproveCriteria.autoApproveAllowed == "Y") {
                    this._storedDataService.areAutoApprovalChangesAllowed = true;
                }

                this._storedDataService.updateRequestedSaved = true;

                this._storedDataService.isEditionComplete = true;
                if (this._storedDataService.pickupDetails && this._storedDataService.pickupDetails.pickupComesFromLocation) {
                    this._storedDataService.isLocationAndPickupEditionComplete = true;
                }
                this.succesModal.open();
            }
        }
    }

    confirmSaveNo() {
        this.confirmSaveModal.close();
    }

    get changeJustification() {
        return this.notificationForm.get('changeJustification').value;
    }
}